import React, { useEffect, useState } from 'react';
import api from './api';
import Modal from './components/Modal';
import toast from 'react-hot-toast';
import { FaTrash, FaPlus } from 'react-icons/fa';

const Apps = () => {
    const [apps, setApps] = useState([]);
    const [form, setForm] = useState({ app_name: '', process_name: '' });
    const [isModalOpen, setModalOpen] = useState(false);
    const isAdmin = JSON.parse(localStorage.getItem('user') || '{}').role === 'admin' || JSON.parse(localStorage.getItem('user') || '{}').role === 'super_admin';

    useEffect(() => {
        fetchApps();
    }, []);

    const fetchApps = async () => {
        try {
            const { data } = await api.get('/apps');
            setApps(data);
        } catch (err) {
            toast.error('Failed to load apps');
        }
    };


    const addApp = async (e) => {
        e.preventDefault();
        try {
            await api.post('/apps', form);
            fetchApps();
            setForm({ app_name: '', process_name: '' });
            setModalOpen(false);
            toast.success('App blocked globally');
        } catch (err) {
            toast.error('Failed to add app');
        }
    };

    const deleteApp = (id) => async () => {
        try {
            await api.delete(`/apps/${id}`);
            fetchApps();
            toast.success('App unblocked');
        } catch (err) {
            toast.error('Failed to remove app');
        }
    };

    return (
        <div className="module">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '30px' }}>
                <div>
                    <h2 style={{ margin: 0, border: 'none', padding: 0 }}>Global Blocklist</h2>
                    {!isAdmin && <p style={{ color: '#45a29e', margin: '10px 0 0 0' }}>These applications are restricted globally.</p>}
                </div>
                {isAdmin && <button onClick={() => setModalOpen(true)} style={{ width: 'auto', margin: 0 }}><FaPlus /> Block New App</button>}
            </div>

            {isAdmin && (
                <p style={{ marginBottom: '20px', color: '#45a29e' }}>
                    Apps added here will be blocked for ALL users by default, unless they have a specific override or "Unlock All" permission.
                </p>
            )}

            <table>
                <thead>
                    <tr>
                        <th>App Name</th>
                        <th>Process</th>
                        <th>Status</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {apps.map(a => (
                        <tr key={a.id}>
                            <td style={{ fontWeight: 'bold', color: '#66fcf1' }}>{a.app_name}</td>
                            <td style={{ fontFamily: 'monospace' }}>{a.process_name}</td>
                            <td>
                                <span className="status blocked">Restricted</span>
                            </td>
                            <td>
                                {isAdmin ? (
                                    <button className="danger" onClick={deleteApp(a.id)} style={{ background: 'rgba(255, 77, 77, 0.1)', border: '1px solid #ff4d4d', color: '#ff4d4d', padding: '5px 15px', width: 'auto' }}>
                                        <FaTrash /> Remove
                                    </button>
                                ) : (
                                    <span style={{ color: '#888' }}>-</span>
                                )}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            <Modal isOpen={isModalOpen} onClose={() => setModalOpen(false)} title="Block Application Globally">
                <form onSubmit={addApp}>
                    <input placeholder="App Name (e.g. Spotify)" value={form.app_name} onChange={e => setForm({ ...form, app_name: e.target.value })} required />
                    <input placeholder="Process Name (e.g. Spotify.exe)" value={form.process_name} onChange={e => setForm({ ...form, process_name: e.target.value })} required />
                    <button style={{ width: '100%' }}>Add to Blocklist</button>
                </form>
            </Modal>
        </div>
    );
};

export default Apps;
